import { fetchCsrfToken, getCookie } from "./authApi";
import { apiClient } from "./apiClient";

export async function fetchReportData({ queryKey }) {
    const [_key, report] = queryKey;
    const response = await apiClient(`/api/reports/types/${report}/data`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}

export async function fetchLastReports({ queryKey }) {
    const [_key, report] = queryKey;
    const response = await apiClient(`/api/reports/types/${report}/last`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    const data = await response.json();
    return Array.isArray(data) ? data : [];
}

export async function generateReport({queryKey}) {
    const [_key, report, reportFormData] = queryKey;

    await fetchCsrfToken();
    const csrfToken = getCookie('csrftoken');

    let body;
    let headers = {
        'Accept': 'application/json',
        'X-CSRFToken': csrfToken,
    };

    body = new FormData();
    for (const [key, value] of Object.entries(reportFormData)) {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                value.forEach(v => body.append(key, v));
            } else {
                body.append(key, value);
            }
        }
    }

    const response = await apiClient(`/api/reports/types/${report}/generate`, {
        method: 'POST',
        headers: headers,
        body: body,
        credentials: 'include',
    });

    return response.json();
}

export async function fetchCurrentReportStatus() {
    try {
        const response = await apiClient(`/api/reports/runs/current/status`, {
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        });
        return response.json();
    } catch (error) {
        if (error.status === 404) {
            return null;
        }
        throw error;
    }
}